import { create } from 'zustand'
import { persist } from "zustand/middleware";
import { ADMIN_ROLES } from '../constants/enums';


export const useCustomerNameStore = create(
    persist(
        (set) => ({
            customerName: null,
            updateCustomerName: (newCustomerName) => set({ customerName: newCustomerName }),
        }),
        {
            name: 'customer-name-store', // key in localStorage
        }
    )
);

export const useCustomerLogoStore = create(
    persist(
        (set) => ({
            customerLogo: 'null',
            updateCustomerLogo: (newCustomerLogo) => set({ customerLogo: newCustomerLogo }),
        }),
        {
            name: "customer_logo", // persists to localStorage
        }
    )
);

export const useSmallCustomerLogoStore = create(
    persist(
        (set) => ({
            smallCustomerLogo: 'null',
            updateSmallCustomerLogo: (newSmallCustomerLogo) => set({ smallCustomerLogo: newSmallCustomerLogo }),
        }),
        {
            name: "small_customer_logo", // persists to localStorage
        }
    )
);

export const useThemeStore = create(
persist(
    (set) => ({
        theme: 'dark',
        updateTheme: (newTheme) => set({ theme: newTheme }),
    }),
    {
        name: "app_theme", // persists to localStorage
    }
));

export const useTimeoutStore = create(
    persist(
        (set) => ({
            timeout: null,
            updateTimeout: (newTimeout) => set({timeout, newTimeout})
        }),
        {
            name: 'timeout_store'
        }
    )
)

export const useRoleNameStore = create(
    persist(
        (set) => ({
            roleName: null,
            updateRoleName: (newRoleName) => set({ roleName: newRoleName.toLowerCase() }),
        }),
        {
            name: "user_role", // key in localStorage
        }
    ));

// Custom hook to compute isAdmin based on roleName
export const useIsAdmin = () => {
    const roleName = useRoleNameStore((state) => state.roleName);
    return [ADMIN_ROLES.SUPER_ADMIN, ADMIN_ROLES.ADMINSTRATOR].includes(roleName);
};

export const useIsSuperAdmin = () => {
    const roleName = useRoleNameStore((state) => state.roleName);
    return roleName === ADMIN_ROLES.SUPER_ADMIN;
};

export const useIsOrbitalUser = () => {
    const customerName = useCustomerNameStore((state) => state.customerName);
    return customerName === "Orbital";
}

export const useIsValidator = () => {
    const roleName = useRoleNameStore((state) => state.roleName);
    return roleName === ADMIN_ROLES.VALIDATOR;
};


export const useMobileStore = create((set) => {
    // Check if window is available (client-side only)
    const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 768 : false;
    
    // Set up resize listener
    if (typeof window !== 'undefined') {
        const handleResize = () => {
            set({ isMobile: window.innerWidth <= 768 });
        };
        
        window.addEventListener('resize', handleResize);
    }
    
    return {
        isMobile,
        setIsMobile: (mobile) => set({ isMobile: mobile }),
    };
});

//Writen with BOBI -- RH
export const usePaginationStore = create(
    persist(
        (set) => ({
            pagination: { current: 1, pageSize: 10, total: 10 },
            updatePagination: (newPaginationOrFn) =>
                set((state) => ({
                    pagination: typeof newPaginationOrFn === 'function'
                        ? newPaginationOrFn(state.pagination)
                        : newPaginationOrFn,
                })),
        }),
        {
            name: "pagination",
        }
    )
);

export const useDeploymentListStore = create(
    persist(
        (set) => ({
            deployments: [],
            addDeployment: (deployment) =>
                set((state) => {
                    // Avoid duplicates
                    const exists = state.deployments.some(
                        d => d.deployment_id === deployment.deployment_id
                    );
                    if (exists) return state;
                    return { deployments: [...state.deployments, deployment] };
                }),
            clearDeployments: () => set({ deployments: [] }),
        }),
        {
            name: "deployment_list",
        }
    )
);